var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { width: "40", height: "40", fill: "#E1F7F7", rx: "8" }),
      React.createElement("path", { d: "M8 8h24v24H8z" }),
      React.createElement("path", { fill: "#018489", d: "M9.437 18.174l10.27-7a1 1 0 0 1 1.03-.059l.117.073 9.73 7a1 1 0 0 1-1.062 1.69l-.106-.066L28 18.792V28a1 1 0 0 1-.883.993L27 29H13a1 1 0 0 1-.993-.883L12 28v-9.154l-1.437.98a1 1 0 0 1-1.312-.164l-.077-.099a1 1 0 0 1 .164-1.312l.099-.077 10.27-7-10.27 7zm10.818-4.953L14 17.483V27h12v-9.646l-5.745-4.133z" })
    )
  );
});